import Reveal     from '../components/Reveal';
import CharReveal from '../components/CharReveal';

export default function Manifiesto() {
  return (
    <section
      id="manifiesto"
      aria-label="Manifiesto"
      className="relative bg-carbon p-4 md:p-6"
    >
      <div
        className="relative rounded-3xl md:rounded-[2rem] overflow-hidden min-h-screen bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(20,17,13,0.55) 0%, rgba(20,17,13,0.45) 50%, rgba(20,17,13,0.85) 100%), url('/baqueano-hero-end.jpg')",
        }}
      >
        <div className="relative flex flex-col gap-10 md:gap-14 px-8 md:px-16 py-24 md:py-32">
          <Reveal>
            <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-senal/85">
              01 · MANIFIESTO
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <h2
              className="font-display font-display-axes font-normal text-papel leading-[0.95] tracking-[-0.02em] max-w-5xl"
              style={{ fontSize: 'clamp(36px, 7vw, 96px)' }}
            >
              No llegamos con un mapa.
            </h2>
          </Reveal>

          <Reveal delay={0.25}>
            <h2
              className="font-display italic font-display-italic-axes font-normal text-tierra leading-[0.95] tracking-[-0.02em] md:whitespace-nowrap"
              style={{ fontSize: 'clamp(32px, 5vw, 80px)' }}
            >
              Llegamos conociendo el terreno.
            </h2>
          </Reveal>

          <p
            className="text-papel/85 leading-[1.6] max-w-3xl mt-4"
            style={{ fontSize: 'clamp(17px, 1.8vw, 22px)' }}
          >
            <CharReveal text="La IA cambia cada semana. Las empresas pierden meses eligiendo herramientas, integrando demos, esperando un piloto que nunca termina. Un baqueano no improvisa: repite el camino hasta que la niebla deja de ser problema." />
          </p>
        </div>
      </div>
    </section>
  );
}
